<template>
    <div class="content"
    >
        <div class="container">
            <h1 class="mb-5">
                WooCommerce Stores
            </h1>

            <card-box v-if="connectedStores.length > 0">
                <card-title>Connected stores</card-title>
                <div class="table-fluid">
                    <table class="table table-striped table-responsive mt-3 w-100 d-block d-md-table table-hover">
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                            <th class="text-right">Setting</th>
                        </tr>
                        <tbody>
                        <tr v-for="item in connectedStores" :key="item.id">
                            <td v-html="item.name">
                            </td>
                            <td width="100"><span class="btn btn-sm btn-status"
                                      :class="{'btn-success':item.status == 1,'btn-light': item.status == 0}">{{item.status == 1 ? 'Active':'Inactive'}}</span>

                            </td>

                            <td class="text-right" width="100">
                                <router-link
                                        :to="{name: 'integrate_woocommerce_edit', params: { id: item.id }}"
                                        class="btn btn-light btn-sm mr-1"><i
                                        class="dripicons-document-edit"></i>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </card-box>

            <div class="row">
                <div class="col-md-6">
                    <card-box>
                        <card-title>Connect your WooCommerce Store</card-title>
                        <div class="form-group mt-3">
                            <label for="name">Name</label>
                            <input required id="name" v-model="storeName" type="text" class="form-control"
                                   placeholder="Store name">
                        </div>

                        <div class="form-group">
                            <label for="storeUrl">Url</label>
                            <input required id="storeUrl" v-model="storeUrl" type="text" class="form-control"
                                   placeholder="http://">
                        </div>
                        <button type="submit" class="btn btn-primary" @click="save">
                            Connect
                        </button>
                    </card-box>
                </div>
                <div class="col-md-6">
                    <card-box>
                        <img src="../../assets/images/woocommerce.svg" height="40" alt="">
                        <p class="mt-3"> Follow these steps to connect your WooCommerce store to your GearFury
                            account.</p>
                        <ul class="mt-3">
                            <li>Step 1: Upgrade your WooCommerce to the latest version
                            </li>
                            <li>Step 2: Make sure that permalink settings are not set to Plain
                                <br>
                                <small>1. Open "Settings → Permalinks" <br>
                                    2. Under "Common Settings" choose any other link structure other than "Plain" in
                                    order for the WooCommerce API to work.
                                </small>

                            </li>
                            <li>Step 3: Install the GearFury plugin</li>
                            <li>Step 4: Connect your WooCommerce to Gearfury</li>
                            <li>Step 5: Start adding products <br>
                                <small>Through the GearFury plugin you can automatically create products, their mockup
                                    images, descriptions, and pricing with just a few clicks. Start now and
                                    add your first product!</small>

                            </li>
                        </ul>
                    </card-box>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CardTitle from "@/components/CardTitle";
    import CardBox from "@/components/CardBox";

    export default {
        name: "WooConnect",
        components: {CardBox, CardTitle},
        data: function () {
            return {
                storeName: '',
                storeUrl: '',
                connectedStores: []
            }
        },


        mounted: function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'integrate_woocommerce')
            this.$store.commit('ACTIVE_SIDEBARSUB', 'integrate_woocommerce')
            this.list()
        },

        methods: {
            list: function () {
                let vm = this
                this.$http.get(this.$config.api + 'integrate/stores/' + this.$config.integrate_types.woocommerce).then(function (res) {
                    vm.connectedStores = res.data
                })
            },
            save: async function () {
                let vm = this

                if (this.storeName == '') {
                    this.$toasted.show('Please enter Store Name', {duration: 2000, position: 'bottom-center'})
                    return false
                }
                if (this.storeUrl == '') {
                    this.$toasted.show('Please enter Store URL', {duration: 2000, position: 'bottom-center'})
                    return false
                }

                let res = await this.$http.post(this.$config.api + 'integrate/token/woocommerce', {
                    store_name: this.storeName,
                    store_url: this.storeUrl
                })
                let token = res.data.token

                const store_url = this.storeUrl;
                const endpoint = '/wc-auth/v1/authorize';
                const params = {
                    app_name: this.$config.integrates.woocommerce.name,
                    scope: 'read_write',
                    user_id: token,
                    return_url: this.$config.integrates.woocommerce.return_url,
                    callback_url: this.$config.integrates.woocommerce.callback_url
                };
                let query_string = Object.keys(params).map(function (key) {
                    return key + '=' + params[key];
                }).join('&');
                window.location.href = store_url + endpoint + '?' + query_string

            },


        }
    }
</script>

<style lang="scss" scoped>
.btn-status {
    min-width: 70px;
}
</style>
